import React, { useEffect, useState } from "react";
import { baseAxios } from "../../apis";
import Pagination from "../commons/Pagination";
import moment from "moment";
import { formatCrypto } from "../../utils";
import SkeletonCard from "../skeletons/SkeletonCard";
import { useBotDemo } from "../../context/botDemoContext";

export const TradeHistoryBot = () => {
  const { selectedBot } = useBotDemo();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tradeHistories, setTradeHistories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedBot) {
      (async function () {
        setLoading(true);
        try {
          const { data } = await baseAxios.get(`/api/demo/bot_history`, {
            params: {
              bot_id: selectedBot?.id,
              page: page,
              limit: limit,
            },
          });
          console.log(data);
          setTotalPages(data?.total_pages);
          setTradeHistories(data?.trade_history);
        } catch (err) {
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [page, limit, selectedBot]);

  const offset = -new Date().getTimezoneOffset() / 60
  const utcLabel = `UTC${offset >= 0 ? "+" : ""}${offset}`

  return (
    <div className="rounded-xl">
      <div className="flex justify-between items-center mb-3 w-full">
        {/* <select
          value={viewCount}
          onChange={(e) => changeViewCount(Number(e.target.value))}
          className="text-sm text-[#344054] border border-[#d0d5dd] rounded-md px-2 py-1 bg-white w-[100px]"
        >
          {[5, 10, 15, 20].map((count) => (
            <option key={count} value={count}>
              View {count}
            </option>
          ))}
        </select> */}
        <div className="relative z-[11] hidden md:flex items-center bg-white text-[#697077] text-sm px-5 pr-3 rounded-lg ml-auto ">
          <span className="mr-2">View</span>
          <select
            name="view-table"
            id="view-table"
            className="border-none cursor-pointer outline-none m-0 text-sm py-1.5"
            onChange={(e) => setLimit(e.target.value)}
            value={limit}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
          </select>
        </div>
      </div>
      <div className="rounded-xl border w-full overflow-x-auto">
        <table className="w-full text-sm text-left text-[#344054] ">
          <thead className="text-xs bg-[#F2F4F8] font-medium text-[#667085] border-b border-[#eaecf0]">
            <tr>
              <th className="p-4 rounded-tl-xl">No.</th>
              <th className="p-4">Pairing</th>
              <th className="p-4">Amount</th>
              <th className="p-4">Profit/Loss (USDT)</th>
              <th className="p-4">Entry Price </th>
              <th className="p-4">Exit Price </th>
              <th className="p-4 rounded-tr-xl">Buy/Sell Time ({utcLabel})</th>
            </tr>
          </thead>
          <tbody className="text-sm text-[#101828]">
            {loading ? (
              [...Array(5)].map((_, idx) => (
                <tr key={idx} className="border-b border-[#f2f4f7] bg-white">
                  <td className={`p-4 text-sm ${4 === idx && "rounded-bl-xl"}`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["70px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className={`p-4 text-sm font-medium`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-4 text-sm">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className={`p-4 text-sm ${4 === idx && "rounded-br-xl"}`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["100px"]}
                      heights={["10px"]}
                    />
                  </td>
                </tr>
              ))
            ) : tradeHistories?.length ? (
              tradeHistories.map((item, idx) => (
                <tr
                  key={item.id}
                  className="border-b border-[#f2f4f7] bg-white"
                >
                  <td
                    className={`p-4 text-sm ${
                      tradeHistories?.length - 1 === idx && "rounded-bl-xl"
                    }`}
                  >
                    {item.id}
                  </td>
                  <td className="p-4 text-sm">{item.coin_name}/USDT</td>
                  <td className="p-4 text-sm">
                    {item.amount} {item.coin_name}
                  </td>
                  <td
                    className={`p-4 text-sm font-medium ${
                      item.profit > 0
                        ? "text-green-600"
                        : item.profit < 0
                        ? "text-red-500"
                        : "text-gray-700"
                    }`}
                  >
                    {formatCrypto(Number(item.pnl))}
                  </td>
                  <td className="p-4 text-sm">
                    {formatCrypto(Number(item.entry_price))} USDT
                  </td>
                  <td className="p-4 text-sm">
                    {formatCrypto(Number(item.close_price))} USDT
                  </td>
                  <td
                    className={`p-4 text-sm ${
                      tradeHistories?.length - 1 === idx && "rounded-br-xl"
                    }`}
                  >
                    {moment(item.created_at).format("DD/MM/YYYY HH:mm")}
                    &nbsp;-&nbsp;
                    {moment(item.updated_at).format("DD/MM/YYYY HH:mm")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="h-[10rem]  p-3 text-sm text-center text-gray-400"
                  colSpan={7}
                >
                  No histories found for this bot.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="items-center justify-center mt-4 md:mt-6 flex">
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </div>
      {/* <div className="flex items-center mt-6 text-sm text-[#667085] gap-4">
        <a
          onClick={() => changePage(page - 1)}
          disabled={page === 1}
          className="!disabled:opacity-50 cursor-pointer"
        >
          <span className="font-medium text-[#101828]">&lt;</span> Previous
        </a>
        <div className="space-x-2">
          {[...Array(totalPages)].map((_, i) => (
            <a
              key={i}
              onClick={() => changePage(i + 1)}
              className={`p-4 rounded-md cursor-pointer ${
                page === i + 1
                  ? "bg-[#F0F0FF] text-[#7f56d9] font-semibold"
                  : "hover:bg-[#f2f4f7]"
              }`}
            >
              {i + 1}
            </a>
          ))}
        </div>
        <a
          onClick={() => changePage(page + 1)}
          disabled={page === totalPages}
          className="disabled:opacity-50 cursor-pointer"
        >
          Next <span className="font-medium text-[#101828]">&gt;</span>
        </a>
      </div> */}
    </div>
  );
};
